// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"8":"c7cfdf6b","388":"190a5196","453":"6b952cb4","478":"80017170","934":"193b67ff"}[chunkId] + ".chunk.js");